import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import { ReadDefaultRate } from "@/schemas/defaultRate";
import { RoleBasedProjectSettlementType } from "@/modules/projects/service/settlementType";

const DefaultRatesAPI = new APIService<ReadDefaultRate>(API.DefaultRates);

interface DefaultRatesGetResponse {
  items: ReadDefaultRate[];
  count: number;
}

interface DefaultRatesServiceOptions {
  settlement_type?: RoleBasedProjectSettlementType;
  valid_from?: string;
}

const defaultRatesQueryParams = (options: DefaultRatesServiceOptions) => {
  const params = new URLSearchParams();
  if (options.settlement_type) {
    params.append("settlement_type", options.settlement_type);
  }
  if (options.valid_from) {
    params.append("valid_from", options.valid_from);
  }
  return params.toString();
};

export const DefaultRatesService = {
  get: (options: DefaultRatesServiceOptions) =>
    DefaultRatesAPI.get<DefaultRatesGetResponse>(
      `resolve?${defaultRatesQueryParams(options)}`,
    ),
};
